export const InlineEmbedIcon = ({ ...other }) => (
  <svg
    fill="none"
    height="163"
    viewBox="0 0 278 163"
    width="278"
    xmlns="http://www.w3.org/2000/svg"
    {...other}
  >
    <g clipPath="url(#clip0_8605_6776)">
      <rect fill="rgb(var(--neeto-ui-white))" height="163" rx="6" width="278" />
      <mask fill="rgb(var(--neeto-ui-white))" id="path-3-inside-1_8605_6776">
        <path d="M0 0h305v20H0z" />
      </mask>
      <path d="M0 0h305v20H0z" fill="rgb(var(--neeto-ui-white))" />
      <path
        d="M305 19H0v2h305z"
        fill="currentColor"
        mask="url(#path-3-inside-1_8605_6776)"
      />
      <circle cx="10.596" cy="10.432" fill="#FD5350" r="2.307" />
      <circle cx="18.143" cy="10.432" fill="#FEB33A" r="2.307" />
      <circle cx="25.69" cy="10.432" fill="#2CC146" r="2.307" />
      <path d="M36 20h206v10H36zM36 150h206v12H36z" fill="currentColor" />
      <rect
        height="103.55"
        rx="5.217"
        stroke="rgb(var(--neeto-ui-gray-300))"
        strokeWidth="0.45"
        width="205.55"
        x="36.225"
        y="38.225"
      />
      <rect
        fill="currentColor"
        height="2.311"
        rx="1.156"
        width="36.079"
        x="45.32"
        y="81.914"
      />
      <rect
        fill="currentColor"
        height="2.311"
        rx="1.156"
        width="20.949"
        x="45.32"
        y="87.688"
      />
      <rect
        fill="#008068"
        height="7.988"
        rx="1"
        width="23.183"
        x="203.539"
        y="61.109"
      />
      <rect
        fill="currentColor"
        height="7.728"
        rx="1"
        width="23.183"
        x="203.539"
        y="73.57"
      />
      <rect
        fill="currentColor"
        height="8.134"
        rx="1"
        width="23.183"
        x="203.539"
        y="85.773"
      />
      <rect
        fill="currentColor"
        height="8.134"
        rx="1"
        width="23.183"
        x="203.539"
        y="98.383"
      />
      <rect
        fill="currentColor"
        height="8.134"
        rx="1"
        width="23.183"
        x="203.539"
        y="110.992"
      />
      <circle cx="52.077" cy="67.819" fill="currentColor" r="6.733" />
      <circle cx="120.314" cy="74.322" fill="currentColor" r="2.65" />
      <circle cx="120.322" cy="84.876" fill="currentColor" r="2.65" />
      <circle cx="120.322" cy="95.439" fill="currentColor" r="2.65" />
      <circle cx="130.954" cy="63.767" fill="currentColor" r="2.65" />
      <circle cx="130.954" cy="74.322" fill="currentColor" r="2.65" />
      <circle cx="130.954" cy="84.876" fill="currentColor" r="2.65" />
      <circle cx="130.954" cy="95.439" fill="currentColor" r="2.65" />
      <circle cx="141.572" cy="63.767" fill="currentColor" r="2.65" />
      <circle cx="141.572" cy="74.322" fill="currentColor" r="2.65" />
      <circle cx="141.572" cy="84.876" fill="currentColor" r="2.65" />
      <circle cx="141.572" cy="95.439" fill="currentColor" r="2.65" />
      <circle cx="152.181" cy="63.767" fill="currentColor" r="2.65" />
      <circle cx="152.181" cy="74.322" fill="currentColor" r="2.65" />
      <circle cx="152.181" cy="84.876" fill="currentColor" r="2.65" />
      <circle cx="162.806" cy="63.767" fill="currentColor" r="2.65" />
      <circle cx="162.806" cy="74.322" fill="#008068" r="2.65" />
      <circle cx="162.806" cy="84.876" fill="currentColor" r="2.65" />
      <circle cx="173.439" cy="63.767" fill="currentColor" r="2.65" />
      <circle cx="173.439" cy="74.322" fill="currentColor" r="2.65" />
      <circle cx="173.439" cy="84.876" fill="currentColor" r="2.65" />
      <circle cx="184.064" cy="63.767" fill="currentColor" r="2.65" />
      <circle cx="184.064" cy="74.322" fill="currentColor" r="2.65" />
      <circle cx="184.075" cy="84.876" fill="currentColor" r="2.65" />
      <path d="M93.023 38v104" stroke="#E7E7E7" strokeWidth="0.454" />
    </g>
    <rect
      height="162"
      rx="5.5"
      stroke="rgb(var(--neeto-ui-gray-300))"
      width="277"
      x="0.5"
      y="0.5"
    />
    <defs>
      <clipPath id="clip0_8605_6776">
        <rect
          fill="rgb(var(--neeto-ui-white))"
          height="163"
          rx="6"
          width="278"
        />
      </clipPath>
    </defs>
  </svg>
);

export const FloatingPopupIcon = ({ ...other }) => (
  <svg
    fill="none"
    height="163"
    viewBox="0 0 278 163"
    width="278"
    xmlns="http://www.w3.org/2000/svg"
    {...other}
  >
    <g clipPath="url(#clip0_9047_10870)">
      <rect fill="rgb(var(--neeto-ui-white))" height="163" rx="6" width="278" />
      <mask fill="rgb(var(--neeto-ui-white))" id="path-3-inside-1_9047_10870">
        <path d="M0 0H305V20H0V0Z" />
      </mask>
      <path d="M0 0H305V20H0V0Z" fill="rgb(var(--neeto-ui-white))" />
      <path
        d="M305 19H0V21H305V19Z"
        fill="currentColor"
        mask="url(#path-3-inside-1_9047_10870)"
      />
      <circle cx="10.5963" cy="10.4322" fill="#FD5350" r="2.30723" />
      <circle cx="18.1432" cy="10.4322" fill="#FEB33A" r="2.30723" />
      <circle cx="25.69" cy="10.4322" fill="#2CC146" r="2.30723" />
      <rect
        fill="currentColor"
        height="3"
        opacity="0.78"
        rx="1.5"
        width="84.6936"
        x="145"
        y="63"
      />
      <rect
        fill="currentColor"
        height="3"
        opacity="0.78"
        rx="1.5"
        width="89"
        x="145"
        y="70"
      />
      <rect
        fill="currentColor"
        height="3"
        opacity="0.78"
        rx="1.5"
        width="49"
        x="145"
        y="77"
      />
      <rect
        fill="currentColor"
        height="3"
        opacity="0.78"
        rx="1.5"
        width="84.6936"
        x="36"
        y="111"
      />
      <rect
        fill="currentColor"
        height="3"
        opacity="0.78"
        rx="1.5"
        width="89"
        x="36"
        y="118"
      />
      <rect
        fill="currentColor"
        height="3"
        opacity="0.78"
        rx="1.5"
        width="25.8387"
        x="36"
        y="125"
      />
      <rect fill="currentColor" height="35" width="96" x="36" y="57" />
      <rect fill="currentColor" height="35" width="95" x="145" y="102" />
      <rect fill="currentColor" height="26" width="204" x="36" y="20" />
      <rect fill="currentColor" height="14" width="204" x="36" y="148" />
    </g>
    <rect
      height="162"
      rx="5.5"
      stroke="rgb(var(--neeto-ui-gray-300))"
      width="277"
      x="0.5"
      y="0.5"
    />
    <rect fill="#008068" height="18" rx="9" width="69" x="194" y="134" />
    <defs>
      <clipPath id="clip0_9047_10870">
        <rect
          fill="rgb(var(--neeto-ui-white))"
          height="163"
          rx="6"
          width="278"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ElementPopupIcon = ({ ...other }) => (
  <svg
    fill="none"
    height="163"
    viewBox="0 0 278 163"
    width="278"
    xmlns="http://www.w3.org/2000/svg"
    {...other}
  >
    <g clipPath="url(#clip0_9047_10869)">
      <rect fill="rgb(var(--neeto-ui-white))" height="163" rx="6" width="278" />
      <mask fill="rgb(var(--neeto-ui-white))" id="path-3-inside-1_9047_10869">
        <path d="M0 0h305v20H0z" />
      </mask>
      <path d="M0 0h305v20H0z" fill="rgb(var(--neeto-ui-white))" />
      <path
        d="M305 19H0v2h305z"
        fill="currentColor"
        mask="url(#path-3-inside-1_9047_10869)"
      />
      <circle cx="10.596" cy="10.432" fill="#FD5350" r="2.307" />
      <circle cx="18.143" cy="10.432" fill="#FEB33A" r="2.307" />
      <circle cx="25.69" cy="10.432" fill="#2CC146" r="2.307" />
    </g>
    <rect
      height="162"
      rx="5.5"
      stroke="rgb(var(--neeto-ui-gray-300))"
      width="277"
      x="0.5"
      y="0.5"
    />
    <rect
      fill="currentColor"
      height="3.944"
      opacity="0.78"
      rx="1.972"
      width="85"
      x="135"
      y="58.461"
    />
    <rect
      fill="currentColor"
      height="3.944"
      opacity="0.78"
      rx="1.972"
      width="89"
      x="135"
      y="66.352"
    />
    <rect fill="#008068" height="7" rx="3.5" width="38" x="135" y="74" />
    <rect
      fill="currentColor"
      height="3.944"
      opacity="0.78"
      rx="1.972"
      width="85"
      x="135"
      y="100.859"
    />
    <rect
      fill="currentColor"
      height="3.944"
      opacity="0.78"
      rx="1.972"
      width="89"
      x="135"
      y="108.75"
    />
    <rect
      fill="currentColor"
      height="3.944"
      opacity="0.78"
      rx="1.972"
      width="26"
      x="135"
      y="116.641"
    />
    <path
      d="M36 52h88v34H36zM36 20h204v28H36zM240 162H36v-28h204zM36 90h88v41H36z"
      fill="currentColor"
    />
    <defs>
      <clipPath id="clip0_9047_10869">
        <rect
          fill="rgb(var(--neeto-ui-white))"
          height="163"
          rx="6"
          width="278"
        />
      </clipPath>
    </defs>
  </svg>
);
